import * as model from './model.js';
import recipeView from './views/recipeView.js';
import searchView from './views/searchView.js';
import renderSearchView from './views/renderSearchView.js';
import paginationView from './views/paginationView.js';
import bookMarkView from './views/bookMarkView.js';
import addRecipeView from './views/addRecipeView.js';

// https://forkify-api.herokuapp.com/v2

///////////////////////////////////////

const showRecipe = async function () {
  try {
    const id = window.location.hash.slice(1);
    if (!id) return;
    recipeView.renderSpinner();
    bookMarkView.update(model.state.bookmarks);
    renderSearchView.update(model.getSaerchResultPage());
    // loading recipe
    await model.loadRecipe(id);
    // Rendering recipe
    recipeView.render(model.state.recipe);
  } catch (err) {
    recipeView.renderError();
  }
};

const showSearch = async function () {
  try {
    // getting value from input field
    const query = searchView.getQuery();
    if (!query) return;
    renderSearchView.renderSpinner();
    // getting
    await model.loadSearch(query);
    renderSearchView.render(model.getSaerchResultPage());
    paginationView.render(model.state.search);
  } catch (err) {
    renderSearchView.renderError();
  }
};

const pageHandlerFn = function (goto) {
  //render new result
  renderSearchView.render(model.getSaerchResultPage(goto));
  // render new pagination
  paginationView.render(model.state.search);
};

const updateServing = function (newServing) {
  model.updateServing(newServing);
  recipeView.update(model.state.recipe);
};

const updateBookmark = function () {
  if (!model.state.recipe.bookmark) model.addBookmark(model.state.recipe);
  else model.removeBookmark(model.state.recipe.id);
  recipeView.update(model.state.recipe);
  bookMarkView.render(model.state.bookmarks);
};

const controlInitialBookmark = function () {
  bookMarkView.render(model.state.bookmarks);
};

const controlRecipeData = async function (data) {
  // console.log(data);
  try {
    //Get data
    await model.uploadDataCall(data);
    //Render spinner
    addRecipeView.renderSpinner();
    // Rendering bookmark
    bookMarkView.render(model.state.bookmarks);
    // Fixing url id bug
    window.history.pushState(null, '', `#${model.state.recipe.id}`);
    //Rendering recipe
    recipeView.render(model.state.recipe);
    //closing overlayWindow
    addRecipeView.toogleClassFn();
  } catch (err) {
    console.log(err);
    addRecipeView.renderError(err.message);
  }
};

const init = function () {
  bookMarkView.addHandlerRender(controlInitialBookmark);
  recipeView.renderHandler(showRecipe);
  searchView.renderHandler(showSearch);
  paginationView.addHandler(pageHandlerFn);
  recipeView.updateHandlerServings(updateServing);
  recipeView.addHandlerBookmark(updateBookmark);
  addRecipeView.adduploadHandler(controlRecipeData);
};

init();
